import React from "react";
import SocialIcons from "./reusables/SocialIcons";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa";

function Hero() {
	return (
		<div id='Hero' className='isolate bg-transparent py-20 sm:py-24'>
			<div className='relative mx-auto max-w-7xl px-4 lg:px-16 mt-24 sm:mt-0'>
				<div className=' max-w-2xl justify-end '>
					<img
						className='absolute inset-0 object-cover mt-2 pl-72 ml-96 h-full z-[-1] hidden sm:block'
						src='https://avatars.githubusercontent.com/u/39589537?v=4'
						alt='Martins Akhivbareme'
					/>

					<div className='hidden sm:flex sm:justify-left'>
						<div className='border-b-8 border-gray-900 w-32 mt-16'></div>
					</div>
					<div className='text-left mt-6'>
						<h1 className='text-4xl font-bold leading-10 md:leading-tight tracking-wide text-gray-900 sm:text-6xl md:mt-0 text-center md:text-left'>
							I'M MARTINS A SOFTWARE ENGINEER
						</h1>

						<p className='text-lg leading-8 text-gray-600 text-center md:text-left mt-12 sm:mt-4'>
							I craft highly-performing websites, mobile apps and webapps that
							are conversion-focused, brand-accurate and people friendly.
						</p>

						<div className='flex justify-left gap-x-6 mt-12 sm:mt-6'>
							<Link
								to={"https://wa.me/+2348167976085"}
								target='_blank'
								className='bg-gray-900 px-7 py-4 text-sm font-bold tracking-wide text-white shadow-sm hover:bg-transparent hover:border-gray-900 hover:text-gray-900 border-2 border-gray-900 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600 mx-auto md:mx-0'>
								LET’S TALK <span aria-hidden='true'>&rarr;</span>
							</Link>
						</div>

						<div className='absolute right-16 z-50 md:block hidden'>
							<a href='#Services'>
								<div className='bg-gray-900 text-white rounded-full p-8 cursor-pointer '>
									<FaAngleDown size={26} />
								</div>
							</a>
						</div>

						<div className='flex flex-col items-left justify-left space-y-2 text-center md:text-left mt-12 sm:mt-0'>
							<p className='mt-6 mb-2 text-gray-900 text-lg font-semibold'>
								Follow me:
							</p>
							<div className='flex justify-center md:justify-start md:space-x-6'>
								<SocialIcons />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Hero;
